import { render, staticRenderFns } from "./YsyLogin.vue?vue&type=template&id=07c2a952&"
import script from "./YsyLogin.vue?vue&type=script&lang=js&"
export * from "./YsyLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports